import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';

import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { GraphApiModule } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { UserRequestComponent } from './user-request/user-request.component';
import { UserRequestDialogService } from './services/user-request-dialog.service';
import { NgPipesModule } from 'ngx-pipes';
import { PipesModule } from '@content-platform/web-angular-shared-util-pipes';
import { AppAutoCompleteModule } from '@content-platform/reusable-ui/custom-material-components';
import { WebAngularSharedUtilEmailApiModule } from '@content-platform/web/angular/shared/util/email-api';
import { RoleSelectCloneModule } from '@content-platform/reusable-ui/role-select-clone';
import { UserSearchAdModule } from '@content-platform/reusable-ui/user-search-ad';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatCardModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatMenuModule,
    MatOptionModule,
    MatTabsModule,
    AuthModule,
    GraphApiModule,
    DevelopmentModule,
    NgPipesModule,
    PipesModule,
    AppAutoCompleteModule,
    WebAngularSharedUtilEmailApiModule,
    RoleSelectCloneModule,
    UserSearchAdModule,
  ],
  exports: [],
  providers: [UserRequestDialogService],
  declarations: [UserRequestComponent],
  entryComponents: [UserRequestComponent],
})
export class ReusableUiUserRequestModule {}
